//============================
//# csisyncdictionary
//# Interfész szinkron mappelés a felület választóihoz (külső kód + K2D megnevezés)
//============================

export default interface IfaceSyncDictionaryOption {
    /** Külső kód — ez kerül vissza a köztes táblába */
    extCode: string;
    /** K2D törzs azonosító */
    intCode: number;
    /** A K2D törzs rekord megnevezése */
    intName: string;
    /** A mappelés külső megnevezése, ha a szótárban meg van adva */
    extName: string;
}

/**
 * Választó megjelenítése: "(külső megnevezés - külső kód) K2D megnevezés" — üres külső
 * megnevezésnél "(külső kód) K2D megnevezés", K2D megnevezés nélkül csak a zárójel tartalma
 */
export function optionDisplay(option: IfaceSyncDictionaryOption): string {
    const extName = option.extName?.trim();
    const ext = extName ? `${extName} - ${option.extCode}` : option.extCode;
    return option.intName ? `(${ext}) ${option.intName}` : ext;
}

export const IfaceSyncDictionaryOptionDefaultProps: IfaceSyncDictionaryOption = {
    extCode: "",
    intCode: 1,
    intName: "",
    extName: "",
}
